import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonButton, IonText } from "@ionic/react";

const SkipCounting: React.FC = () => {
    const [sequence, setSequence] = useState<number[]>([]);
    const [missingNumber, setMissingNumber] = useState<number>(0);
    const [options, setOptions] = useState<number[]>([]);
    const [message, setMessage] = useState<string>("");

    useEffect(() => {
        generateNewQuestion();
        document.title = "Mamas Guidance - Class One - Mathematics - Patterns - Skip Counting";
    }, []);

    const generateNewQuestion = () => {
        const start = Math.floor(Math.random() * 89) + 11; // Start from a random number between 1-10
        //const step = Math.floor(Math.random() * 3) + 1; // Step of 1, 2, or 3
        const step = Math.floor(Math.random() * 9) + 1;
        const numbers = Array.from({ length: 5 }, (_, i) => start + i * step);
        const missingIndex = Math.floor(Math.random() * numbers.length);
        const missingValue = numbers[missingIndex];
        numbers[missingIndex] = "?" as any; // Placeholder for missing number

        setSequence(numbers);
        setMissingNumber(missingValue);

        // Generate options
        const wrongOption1 = missingValue + (Math.random() > 0.5 ? 1 : -1);
        const wrongOption2 = missingValue + (Math.random() > 0.5 ? 2 : -2);
        const optionsArray = [missingValue, wrongOption1, wrongOption2].sort(() => Math.random() - 0.5);
        setOptions(optionsArray);
        setMessage("");
    };

    const checkAnswer = (selected: number) => {
        if (selected === missingNumber) {
            setMessage("🎉 Correct! Well done!");
        } else {
            setMessage("❌ Oops! Try again.");
        }
        setTimeout(generateNewQuestion, 1500);
    };

    return (
        <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
            <IonText>
                <h2>Find the Missing Number</h2>
            </IonText>
            <IonText>
                <h1>{sequence.join(" ")}</h1>
            </IonText>
            <div style={{display: 'flex', gap: '30px'}}>
                {options.map((option, index) => (
                    <div className="background-blue" style={{ width: 'auto', padding: '20px', fontSize: '30px' }} key={index} onClick={() => checkAnswer(option)}>
                        {option}
                    </div>
                ))}
            </div>
            {message && <IonText><h3>{message}</h3></IonText>}
        </div>
    );
};

export default SkipCounting;
